(function () {
  function money(n) {
    return "Rs." + Number(n || 0).toLocaleString("en-PK");
  }

  async function variantIdForHandle(handle) {
    const res = await fetch("/products/" + encodeURIComponent(handle) + ".js", { cache: "force-cache" });
    if (!res.ok) throw new Error("Product not found");
    const data = await res.json();
    const v = (data.variants && data.variants[0]) || null;
    return v && v.id ? v.id : null;
  }

  async function syncLocalCartToShopify() {
    var cart = [];
    try {
      cart = JSON.parse(localStorage.getItem("mana_cart") || "[]");
    } catch (_) {}
    if (!cart.length) throw new Error("Cart is empty");

    // Clear Shopify cart then add each line
    try {
      await fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } });
    } catch (_) {}

    for (var i = 0; i < cart.length; i++) {
      var row = cart[i];
      var vid = await variantIdForHandle(row.id);
      if (!vid) continue;
      var add = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: vid, quantity: Math.max(1, Number(row.qty) || 1) })
      });
      if (!add.ok) throw new Error("Could not add item to cart");
    }
  }

  window.manaCheckout = async function manaCheckout(btn) {
    var el = btn || null;
    var prev = el ? el.textContent : "";
    if (el) {
      el.setAttribute("aria-busy", "true");
      el.textContent = "Checking out…";
      el.style.pointerEvents = "none";
    }
    try {
      await syncLocalCartToShopify();
      window.location.href = "/checkout";
    } catch (err) {
      if (el) {
        el.textContent = prev || "Checkout";
        el.style.pointerEvents = "";
        el.removeAttribute("aria-busy");
      }
      var toast = document.getElementById("toast");
      if (toast) {
        toast.textContent = (err && err.message) || "Checkout unavailable";
        toast.hidden = false;
        setTimeout(function () { toast.hidden = true; }, 2200);
      } else {
        alert((err && err.message) || "Checkout unavailable");
      }
    }
  };

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-checkout]");
    if (!btn) return;
    e.preventDefault();
    window.manaCheckout(btn);
  });

  window.manaCartFootHTML = function (totalLabel, waMsg) {
    var total = totalLabel || "";
    var msg = encodeURIComponent(waMsg || "I would like to checkout my cart.");
    return (
      (total ? "<div class=\"sheet__total\">" + total + "</div>" : "") +
      '<div class="sheet__actions">' +
      '<button type="button" class="btn btn-dark" data-checkout>Checkout</button>' +
      '<a class="btn btn-gold" href="https://wa.me/923114711112?text=' + msg + '" target="_blank" rel="noopener">Order on WhatsApp</a>' +
      "</div>"
    );
  };
})();
